// ENERGY — THE TRONSAVE BALANCE, first on the list (his words, 30 Oct 2026: he could not tell where TRX goes). The balance and its
// state, and the deposit address in full with Copy under a plain "Send TRX here". Then ONE FACT A LINE (his words, 1 Nov 2026:
// "Amount, chain, date and time everything in 1st column- doesn't it look wrong"): when a balance not read was last read, the line a
// low one is under, the day's spend and its limit — never two figures in one sentence. A balance TronSave has not answered for is
// said in a red box, in words, never shown as if current. The prices and the whole explanation stay behind Details (the desk sheet).
import type { ReactNode } from 'react';
import type { EnergyStatus } from '../../../lib/api';
import { fmtDay, fmtTime } from '../../../lib/format';
import { Fact, Panel, StateLine, TAP } from '../kit';
import { Pill } from '../../Pill';
import { CopyRef } from '../../CopyRef';
import { V2_SLABS } from './parts';
import { balanceFacts, balanceLine, balanceState, trx } from '../../../screens/Energy';

const when = (iso: string) => `${fmtDay(iso)} ${fmtTime(iso)}`;
const TONE_TEXT = { bad: 'text-neg', warn: 'text-warn', neutral: 'text-tg-text' } as const;
/** A figure, then its unit muted. */
const Figure = ({ value, unit, className = '' }: { value: ReactNode; unit: string | null; className?: string }) => (
  unit === null ? <>{value}</> : <span className="whitespace-nowrap"><span className={`font-mono tabular ${className}`}>{value}</span> <span className="text-meta text-tg-hint">{unit}</span></span>
);

export function BalanceBox({ d, spendTone, onDetails }: { d: EnergyStatus; spendTone: 'warn' | undefined; onDetails: () => void }) {
  const p = d.provider;
  const s = balanceState(p);
  const warning = balanceLine(p, s);
  return (
    <Panel title="TronSave balance" aside={s.word ? <Pill tone={s.tone}>{s.word}</Pill> : undefined}
      action={<button type="button" className={TAP} onClick={onDetails}>Details</button>} className="mb-4 lg:mb-5">
      <div className="space-y-3">
        <p className={`font-mono tabular text-figure ${s.key === 'unread' ? 'text-tg-hint' : TONE_TEXT[s.tone]}`}>
          {p.balanceSun === null ? '—' : <>{trx(p.balanceSun)}&nbsp;<span className="font-sans text-body text-tg-hint">TRX</span></>}
        </p>
        {warning && <StateLine tone="bad" className={V2_SLABS.bad}>{warning}</StateLine>}
        {p.depositAddress && (
          <div className="rounded-lg border border-stroke bg-panel-2 px-3 py-2.5">
            <p className="text-meta font-medium text-tg-text">Send TRX here</p>
            <div className="mt-1 flex items-start justify-between gap-3">
              <span className="min-w-0 break-all font-mono text-body">{p.depositAddress}</span>
              <CopyRef value={p.depositAddress} label="Copy" className="shrink-0" />
            </div>
          </div>
        )}
        <div>
          {balanceFacts(p, s, when).map((f) => <Fact key={f.label} label={f.label}><Figure value={f.value} unit={f.unit} /></Fact>)}
          <Fact label="Spent in 24h"><Figure value={trx(d.spend.countedSun)} unit="TRX" className={spendTone === 'warn' ? 'text-warn' : ''} /></Fact>
          <Fact label="Limit in 24h"><Figure value={trx(d.spend.dailyCapSun)} unit="TRX" /></Fact>
        </div>
      </div>
    </Panel>
  );
}
